import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 form-group mb-7" }
const _hoisted_4 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_5 = { class: "col-md-6 form-group mb-7" }
const _hoisted_6 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_8 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_9 = { class: "col-md-6 form-group mb-7" }
const _hoisted_10 = { class: "fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.sectionTitle), 1),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("kyc.information.common.email")), 1),
        _createVNode(_component_el_form_item, { prop: "email" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.model.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("kyc.information.common.website")), 1),
        _createVNode(_component_el_form_item, { prop: "website" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.model.website,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.website) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      (_ctx.type === _ctx.KycType.Juridical)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("kyc.information.common.tel")), 1),
            _createVNode(_component_el_form_item, { prop: "telephone" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.telephone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.telephone) = $event)),
                  placeholder: _ctx.$t('common.plsEnter'),
                  class: "input-with-select",
                  clearable: "",
                  type: "text"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "hide-error-msg",
                      prop: "area_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.model.area_code,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.area_code) = $event)),
                          clearable: false,
                          loading: _ctx.areaCodesLoading,
                          placeholder: _ctx.$t('common.plsSelect'),
                          autocomplete: "off",
                          style: {"width":"130px"},
                          filterable: true
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaCodesOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: '+' + item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("kyc.information.common.fax")), 1),
        _createVNode(_component_el_form_item, { prop: "fax" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.model.fax,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.fax) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}